import React, { Fragment } from "react";
import { formatTo12HourTime, setCookie } from "@/context/utilities";
import Link from "next/link";

const AnnouncementModal = ({ announcements }) => {
  return (
    <Fragment>
      <div
        className="modal fade"
        id="announcements"
        tabIndex="-1"
        aria-labelledby="announcementsLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-body">
              <div className="modal-overlay">
                <div className="modal-header">
                  <h4 className="text-danger" id="sessionHeading">
                    Announcements
                  </h4>
                </div>

                <div className="rbt-dashboard-table table-responsive mobile-table-750 mt--30">
                  <table className="rbt-table table table-borderless">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      {announcements.map((announce) => {
                        return (
                          <tr key={announce._id}>
                            <th>
                              <span className="h6 mb--5">
                                {new Date(announce.createdAt).toDateString()}
                              </span>
                              <p className="b3">
                                {formatTo12HourTime(announce.createdAt)}
                              </p>
                            </th>
                            <td>
                              <span className="h6 mb--5 rbt-hover-02">
                                {announce.displayName}
                              </span>
                              {announce.link && (
                                <Link href={announce.link}>
                                  <p className="b3">Click To view resources</p>
                                </Link>
                              )}
                              <p className="b3">{announce.description}</p>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="top-circle-shape"></div>
            <div className="modal-footer pt--30">
              <button
                onClick={() => {
                  announcements.map((i) => {
                    setCookie(i._id, "true", 1);
                  });
                }}
                type="button"
                className="rbt-btn btn-border btn-sm radius-round-10"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AnnouncementModal;
